module.exports = __webpack_public_path__ + "img/sucess.80185fb6.svg";